'use client';
import VpDeliveryDhlAsset from './DeliveryDhl.mjs';
import VpDeliveryHermesAsset from './DeliveryHermes.mjs';
import VpFlagAdAsset from './FlagAd.mjs';
import VpFlagAeAsset from './FlagAe.mjs';
import VpFlagAfAsset from './FlagAf.mjs';
import VpFlagAgAsset from './FlagAg.mjs';
import VpFlagAiAsset from './FlagAi.mjs';
import VpFlagAlAsset from './FlagAl.mjs';
import VpFlagAmAsset from './FlagAm.mjs';
import VpFlagAnAsset from './FlagAn.mjs';
import VpFlagAoAsset from './FlagAo.mjs';
import VpFlagArAsset from './FlagAr.mjs';
import VpFlagAsAsset from './FlagAs.mjs';
import VpFlagAtAsset from './FlagAt.mjs';
import VpFlagAuAsset from './FlagAu.mjs';
import VpFlagAwAsset from './FlagAw.mjs';
import VpFlagAxAsset from './FlagAx.mjs';
import VpFlagAzAsset from './FlagAz.mjs';
import VpFlagBaAsset from './FlagBa.mjs';
import VpFlagBbAsset from './FlagBb.mjs';
import VpFlagBdAsset from './FlagBd.mjs';
import VpFlagBeAsset from './FlagBe.mjs';
import VpFlagBfAsset from './FlagBf.mjs';
import VpFlagBgAsset from './FlagBg.mjs';
import VpFlagBhAsset from './FlagBh.mjs';
import VpFlagBiAsset from './FlagBi.mjs';
import VpFlagBjAsset from './FlagBj.mjs';
import VpFlagBlAsset from './FlagBl.mjs';
import VpFlagBmAsset from './FlagBm.mjs';
import VpFlagBnAsset from './FlagBn.mjs';
import VpFlagBoAsset from './FlagBo.mjs';
import VpFlagBrAsset from './FlagBr.mjs';
import VpFlagBsAsset from './FlagBs.mjs';
import VpFlagBtAsset from './FlagBt.mjs';
import VpFlagBvAsset from './FlagBv.mjs';
import VpFlagBwAsset from './FlagBw.mjs';
import VpFlagByAsset from './FlagBy.mjs';
import VpFlagBzAsset from './FlagBz.mjs';
import VpFlagCaAsset from './FlagCa.mjs';
import VpFlagCafAsset from './FlagCaf.mjs';
import VpFlagCasAsset from './FlagCas.mjs';
import VpFlagCcAsset from './FlagCc.mjs';
import VpFlagCdAsset from './FlagCd.mjs';
import VpFlagCeuAsset from './FlagCeu.mjs';
import VpFlagCfAsset from './FlagCf.mjs';
import VpFlagCgAsset from './FlagCg.mjs';
import VpFlagChAsset from './FlagCh.mjs';
import VpFlagCiAsset from './FlagCi.mjs';
import VpFlagCkAsset from './FlagCk.mjs';
import VpFlagClAsset from './FlagCl.mjs';
import VpFlagCmAsset from './FlagCm.mjs';
import VpFlagCnAsset from './FlagCn.mjs';
import VpFlagCnaAsset from './FlagCna.mjs';
import VpFlagCoAsset from './FlagCo.mjs';
import VpFlagCocAsset from './FlagCoc.mjs';
import VpFlagCrAsset from './FlagCr.mjs';
import VpFlagCsaAsset from './FlagCsa.mjs';
import VpFlagCuAsset from './FlagCu.mjs';
import VpFlagCvAsset from './FlagCv.mjs';
import VpFlagCwAsset from './FlagCw.mjs';
import VpFlagCxAsset from './FlagCx.mjs';
import VpFlagCyAsset from './FlagCy.mjs';
import VpFlagCzAsset from './FlagCz.mjs';
import VpFlagDeAsset from './FlagDe.mjs';
import VpFlagDjAsset from './FlagDj.mjs';
import VpFlagDkAsset from './FlagDk.mjs';
import VpFlagDmAsset from './FlagDm.mjs';
import VpFlagDoAsset from './FlagDo.mjs';
import VpFlagDzAsset from './FlagDz.mjs';
import VpFlagEcAsset from './FlagEc.mjs';
import VpFlagEeAsset from './FlagEe.mjs';
import VpFlagEgAsset from './FlagEg.mjs';
import VpFlagEhAsset from './FlagEh.mjs';
import VpFlagErAsset from './FlagEr.mjs';
import VpFlagEsAsset from './FlagEs.mjs';
import VpFlagEtAsset from './FlagEt.mjs';
import VpFlagEuAsset from './FlagEu.mjs';
import VpFlagFiAsset from './FlagFi.mjs';
import VpFlagFjAsset from './FlagFj.mjs';
import VpFlagFkAsset from './FlagFk.mjs';
import VpFlagFmAsset from './FlagFm.mjs';
import VpFlagFoAsset from './FlagFo.mjs';
import VpFlagFrAsset from './FlagFr.mjs';
import VpFlagGaAsset from './FlagGa.mjs';
import VpFlagGbEngAsset from './FlagGbEng.mjs';
import VpFlagGbNirAsset from './FlagGbNir.mjs';
import VpFlagGbSctAsset from './FlagGbSct.mjs';
import VpFlagGbWlsAsset from './FlagGbWls.mjs';
import VpFlagGbZetAsset from './FlagGbZet.mjs';
import VpFlagGbAsset from './FlagGb.mjs';
import VpFlagGdAsset from './FlagGd.mjs';
import VpFlagGeAsset from './FlagGe.mjs';
import VpFlagGfAsset from './FlagGf.mjs';
import VpFlagGgAsset from './FlagGg.mjs';
import VpFlagGhAsset from './FlagGh.mjs';
import VpFlagGiAsset from './FlagGi.mjs';
import VpFlagGlAsset from './FlagGl.mjs';
import VpFlagGmAsset from './FlagGm.mjs';
import VpFlagGnAsset from './FlagGn.mjs';
import VpFlagGpAsset from './FlagGp.mjs';
import VpFlagGqAsset from './FlagGq.mjs';
import VpFlagGrAsset from './FlagGr.mjs';
import VpFlagGsAsset from './FlagGs.mjs';
import VpFlagGtAsset from './FlagGt.mjs';
import VpFlagGuAsset from './FlagGu.mjs';
import VpFlagGwAsset from './FlagGw.mjs';
import VpFlagGyAsset from './FlagGy.mjs';
import VpFlagHkAsset from './FlagHk.mjs';
import VpFlagHmAsset from './FlagHm.mjs';
import VpFlagHnAsset from './FlagHn.mjs';
import VpFlagHrAsset from './FlagHr.mjs';
import VpFlagHtAsset from './FlagHt.mjs';
import VpFlagHuAsset from './FlagHu.mjs';
import VpFlagIdAsset from './FlagId.mjs';
import VpFlagIeAsset from './FlagIe.mjs';
import VpFlagIlAsset from './FlagIl.mjs';
import VpFlagImAsset from './FlagIm.mjs';
import VpFlagInAsset from './FlagIn.mjs';
import VpFlagIoAsset from './FlagIo.mjs';
import VpFlagIqAsset from './FlagIq.mjs';
import VpFlagIrAsset from './FlagIr.mjs';
import VpFlagIsAsset from './FlagIs.mjs';
import VpFlagItAsset from './FlagIt.mjs';
import VpFlagJeAsset from './FlagJe.mjs';
import VpFlagJmAsset from './FlagJm.mjs';
import VpFlagJoAsset from './FlagJo.mjs';
import VpFlagJpAsset from './FlagJp.mjs';
import VpFlagKeAsset from './FlagKe.mjs';
import VpFlagKgAsset from './FlagKg.mjs';
import VpFlagKhAsset from './FlagKh.mjs';
import VpFlagKiAsset from './FlagKi.mjs';
import VpFlagKmAsset from './FlagKm.mjs';
import VpFlagKnAsset from './FlagKn.mjs';
import VpFlagKpAsset from './FlagKp.mjs';
import VpFlagKrAsset from './FlagKr.mjs';
import VpFlagKwAsset from './FlagKw.mjs';
import VpFlagKyAsset from './FlagKy.mjs';
import VpFlagKzAsset from './FlagKz.mjs';
import VpFlagLaAsset from './FlagLa.mjs';
import VpFlagLbAsset from './FlagLb.mjs';
import VpFlagLcAsset from './FlagLc.mjs';
import VpFlagLgbtAsset from './FlagLgbt.mjs';
import VpFlagLiAsset from './FlagLi.mjs';
import VpFlagLkAsset from './FlagLk.mjs';
import VpFlagLrAsset from './FlagLr.mjs';
import VpFlagLsAsset from './FlagLs.mjs';
import VpFlagLtAsset from './FlagLt.mjs';
import VpFlagLuAsset from './FlagLu.mjs';
import VpFlagLvAsset from './FlagLv.mjs';
import VpFlagLyAsset from './FlagLy.mjs';
import VpFlagMaAsset from './FlagMa.mjs';
import VpFlagMcAsset from './FlagMc.mjs';
import VpFlagMdAsset from './FlagMd.mjs';
import VpFlagMeAsset from './FlagMe.mjs';
import VpFlagMfAsset from './FlagMf.mjs';
import VpFlagMgAsset from './FlagMg.mjs';
import VpFlagMhAsset from './FlagMh.mjs';
import VpFlagMkAsset from './FlagMk.mjs';
import VpFlagMlAsset from './FlagMl.mjs';
import VpFlagMmAsset from './FlagMm.mjs';
import VpFlagMnAsset from './FlagMn.mjs';
import VpFlagMoAsset from './FlagMo.mjs';
import VpFlagMpAsset from './FlagMp.mjs';
import VpFlagMqAsset from './FlagMq.mjs';
import VpFlagMrAsset from './FlagMr.mjs';
import VpFlagMsAsset from './FlagMs.mjs';
import VpFlagMtAsset from './FlagMt.mjs';
import VpFlagMuAsset from './FlagMu.mjs';
import VpFlagMvAsset from './FlagMv.mjs';
import VpFlagMwAsset from './FlagMw.mjs';
import VpFlagMxAsset from './FlagMx.mjs';
import VpFlagMyAsset from './FlagMy.mjs';
import VpFlagMzAsset from './FlagMz.mjs';
import VpFlagNaAsset from './FlagNa.mjs';
import VpFlagNcAsset from './FlagNc.mjs';
import VpFlagNeAsset from './FlagNe.mjs';
import VpFlagNfAsset from './FlagNf.mjs';
import VpFlagNgAsset from './FlagNg.mjs';
import VpFlagNiAsset from './FlagNi.mjs';
import VpFlagNlAsset from './FlagNl.mjs';
import VpFlagNoAsset from './FlagNo.mjs';
import VpFlagNpAsset from './FlagNp.mjs';
import VpFlagNrAsset from './FlagNr.mjs';
import VpFlagNuAsset from './FlagNu.mjs';
import VpFlagNzAsset from './FlagNz.mjs';
import VpFlagOmAsset from './FlagOm.mjs';
import VpFlagPaAsset from './FlagPa.mjs';
import VpFlagPeAsset from './FlagPe.mjs';
import VpFlagPfAsset from './FlagPf.mjs';
import VpFlagPgAsset from './FlagPg.mjs';
import VpFlagPhAsset from './FlagPh.mjs';
import VpFlagPkAsset from './FlagPk.mjs';
import VpFlagPlAsset from './FlagPl.mjs';
import VpFlagPmAsset from './FlagPm.mjs';
import VpFlagPnAsset from './FlagPn.mjs';
import VpFlagPrAsset from './FlagPr.mjs';
import VpFlagPsAsset from './FlagPs.mjs';
import VpFlagPtAsset from './FlagPt.mjs';
import VpFlagPwAsset from './FlagPw.mjs';
import VpFlagPyAsset from './FlagPy.mjs';
import VpFlagQaAsset from './FlagQa.mjs';
import VpFlagReAsset from './FlagRe.mjs';
import VpFlagRoAsset from './FlagRo.mjs';
import VpFlagRsAsset from './FlagRs.mjs';
import VpFlagRuAsset from './FlagRu.mjs';
import VpFlagRwAsset from './FlagRw.mjs';
import VpFlagSaAsset from './FlagSa.mjs';
import VpFlagSbAsset from './FlagSb.mjs';
import VpFlagScAsset from './FlagSc.mjs';
import VpFlagSdAsset from './FlagSd.mjs';
import VpFlagSeAsset from './FlagSe.mjs';
import VpFlagSgAsset from './FlagSg.mjs';
import VpFlagShAsset from './FlagSh.mjs';
import VpFlagSiAsset from './FlagSi.mjs';
import VpFlagSjAsset from './FlagSj.mjs';
import VpFlagSkAsset from './FlagSk.mjs';
import VpFlagSlAsset from './FlagSl.mjs';
import VpFlagSmAsset from './FlagSm.mjs';
import VpFlagSnAsset from './FlagSn.mjs';
import VpFlagSoAsset from './FlagSo.mjs';
import VpFlagSrAsset from './FlagSr.mjs';
import VpFlagSsAsset from './FlagSs.mjs';
import VpFlagStAsset from './FlagSt.mjs';
import VpFlagSvAsset from './FlagSv.mjs';
import VpFlagSxAsset from './FlagSx.mjs';
import VpFlagSyAsset from './FlagSy.mjs';
import VpFlagSzAsset from './FlagSz.mjs';
import VpFlagTcAsset from './FlagTc.mjs';
import VpFlagTdAsset from './FlagTd.mjs';
import VpFlagTgAsset from './FlagTg.mjs';
import VpFlagThAsset from './FlagTh.mjs';
import VpFlagTjAsset from './FlagTj.mjs';
import VpFlagTkAsset from './FlagTk.mjs';
import VpFlagTlAsset from './FlagTl.mjs';
import VpFlagTmAsset from './FlagTm.mjs';
import VpFlagTnAsset from './FlagTn.mjs';
import VpFlagToAsset from './FlagTo.mjs';
import VpFlagTrAsset from './FlagTr.mjs';
import VpFlagTtAsset from './FlagTt.mjs';
import VpFlagTvAsset from './FlagTv.mjs';
import VpFlagTzAsset from './FlagTz.mjs';
import VpFlagUaAsset from './FlagUa.mjs';
import VpFlagUgAsset from './FlagUg.mjs';
import VpFlagUmAsset from './FlagUm.mjs';
import VpFlagUsCaAsset from './FlagUsCa.mjs';
import VpFlagUsAsset from './FlagUs.mjs';
import VpFlagUyAsset from './FlagUy.mjs';
import VpFlagUzAsset from './FlagUz.mjs';
import VpFlagVaAsset from './FlagVa.mjs';
import VpFlagVcAsset from './FlagVc.mjs';
import VpFlagVeAsset from './FlagVe.mjs';
import VpFlagVgAsset from './FlagVg.mjs';
import VpFlagViAsset from './FlagVi.mjs';
import VpFlagVnAsset from './FlagVn.mjs';
import VpFlagVuAsset from './FlagVu.mjs';
import VpFlagWfAsset from './FlagWf.mjs';
import VpFlagWsAsset from './FlagWs.mjs';
import VpFlagWwAsset from './FlagWw.mjs';
import VpFlagXkAsset from './FlagXk.mjs';
import VpFlagYeAsset from './FlagYe.mjs';
import VpFlagYtAsset from './FlagYt.mjs';
import VpFlagZaAsset from './FlagZa.mjs';
import VpFlagZmAsset from './FlagZm.mjs';
import VpFlagZwAsset from './FlagZw.mjs';
import VpLogoDecathlonCoreSymbolBrandAsset from './LogoDecathlonCoreSymbolBrand.mjs';
import VpLogoDecathlonCoreSymbolWhiteAsset from './LogoDecathlonCoreSymbolWhite.mjs';
import VpLogoDecathlonFaviconAsset from './LogoDecathlonFavicon.mjs';
import VpLogoDecathlonLockupPrimaryBrandAsset from './LogoDecathlonLockupPrimaryBrand.mjs';
import VpLogoDecathlonLockupPrimaryWhiteAsset from './LogoDecathlonLockupPrimaryWhite.mjs';
import VpLogoDecathlonLockupStackedBrandAsset from './LogoDecathlonLockupStackedBrand.mjs';
import VpLogoDecathlonLockupStackedWhiteAsset from './LogoDecathlonLockupStackedWhite.mjs';
import VpLogoDecathlonStorePinSelectedAsset from './LogoDecathlonStorePinSelected.mjs';
import VpLogoDecathlonStorePinAsset from './LogoDecathlonStorePin.mjs';
import VpLogoDecathlonWordmarkBrandAsset from './LogoDecathlonWordmarkBrand.mjs';
import VpLogoDecathlonWordmarkWhiteAsset from './LogoDecathlonWordmarkWhite.mjs';
import VpPaymentAddiAsset from './PaymentAddi.mjs';
import VpPaymentAffirmAsset from './PaymentAffirm.mjs';
import VpPaymentAfterpayRivertyAsset from './PaymentAfterpayRiverty.mjs';
import VpPaymentAfterpayAsset from './PaymentAfterpay.mjs';
import VpPaymentAlipayAsset from './PaymentAlipay.mjs';
import VpPaymentAmazonpayAsset from './PaymentAmazonpay.mjs';
import VpPaymentAmexAsset from './PaymentAmex.mjs';
import VpPaymentApplepayAsset from './PaymentApplepay.mjs';
import VpPaymentAtomeAsset from './PaymentAtome.mjs';
import VpPaymentBancontactClassicAsset from './PaymentBancontactClassic.mjs';
import VpPaymentBancontactPayconiqAsset from './PaymentBancontactPayconiq.mjs';
import VpPaymentBelfiusAsset from './PaymentBelfius.mjs';
import VpPaymentBitcoinAcceptedHereAsset from './PaymentBitcoinAcceptedHere.mjs';
import VpPaymentBitcoinLogoAsset from './PaymentBitcoinLogo.mjs';
import VpPaymentBitpayAsset from './PaymentBitpay.mjs';
import VpPaymentBoletoAsset from './PaymentBoleto.mjs';
import VpPaymentBvrAsset from './PaymentBvr.mjs';
import VpPaymentCadhocAsset from './PaymentCadhoc.mjs';
import VpPaymentCashAsset from './PaymentCash.mjs';
import VpPaymentCbAsset from './PaymentCb.mjs';
import VpPaymentCheckAsset from './PaymentCheck.mjs';
import VpPaymentCitadeleAsset from './PaymentCitadele.mjs';
import VpPaymentClickandbuyAsset from './PaymentClickandbuy.mjs';
import VpPaymentDinersclubinternationalAsset from './PaymentDinersclubinternational.mjs';
import VpPaymentDiscoverAsset from './PaymentDiscover.mjs';
import VpPaymentDwollaAsset from './PaymentDwolla.mjs';
import VpPaymentEloAsset from './PaymentElo.mjs';
import VpPaymentEpsAsset from './PaymentEps.mjs';
import VpPaymentEthereumAsset from './PaymentEthereum.mjs';
import VpPaymentEwayAsset from './PaymentEway.mjs';
import VpPaymentGiropayAsset from './PaymentGiropay.mjs';
import VpPaymentGooglepayAsset from './PaymentGooglepay.mjs';
import VpPaymentGrabAsset from './PaymentGrab.mjs';
import VpPaymentHipercardAsset from './PaymentHipercard.mjs';
import VpPaymentIdealAsset from './PaymentIdeal.mjs';
import VpPaymentIllicadoAsset from './PaymentIllicado.mjs';
import VpPaymentIngAsset from './PaymentIng.mjs';
import VpPaymentIngenicoAsset from './PaymentIngenico.mjs';
import VpPaymentInteracAsset from './PaymentInterac.mjs';
import VpPaymentJcbAsset from './PaymentJcb.mjs';
import VpPaymentKbcAsset from './PaymentKbc.mjs';
import VpPaymentKlarnaAsset from './PaymentKlarna.mjs';
import VpPaymentKueskipayAsset from './PaymentKueskipay.mjs';
import VpPaymentLaybuy1Asset from './PaymentLaybuy1.mjs';
import VpPaymentLaybuyAsset from './PaymentLaybuy.mjs';
import VpPaymentLayupAsset from './PaymentLayup.mjs';
import VpPaymentMaestroLogoAsset from './PaymentMaestroLogo.mjs';
import VpPaymentMaestroWithTextAsset from './PaymentMaestroWithText.mjs';
import VpPaymentMastercardIdCheckAsset from './PaymentMastercardIdCheck.mjs';
import VpPaymentMastercardLogoAsset from './PaymentMastercardLogo.mjs';
import VpPaymentMastercardWithTextAsset from './PaymentMastercardWithText.mjs';
import VpPaymentMbMultibancoAsset from './PaymentMbMultibanco.mjs';
import VpPaymentMbWayAsset from './PaymentMbWay.mjs';
import VpPaymentMercadoPagoAsset from './PaymentMercadoPago.mjs';
import VpPaymentMnpAsset from './PaymentMnp.mjs';
import VpPaymentMoneroAsset from './PaymentMonero.mjs';
import VpPaymentNetellerAsset from './PaymentNeteller.mjs';
import VpPaymentOney3X4XAsset from './PaymentOney3X4X.mjs';
import VpPaymentOney3XAsset from './PaymentOney3X.mjs';
import VpPaymentOney4XAsset from './PaymentOney4X.mjs';
import VpPaymentOneyLogoAsset from './PaymentOneyLogo.mjs';
import VpPaymentPaceAsset from './PaymentPace.mjs';
import VpPaymentPagodilAsset from './PaymentPagodil.mjs';
import VpPaymentPaylibAsset from './PaymentPaylib.mjs';
import VpPaymentPaymillAsset from './PaymentPaymill.mjs';
import VpPaymentPayoneerAsset from './PaymentPayoneer.mjs';
import VpPaymentPaypalAsset from './PaymentPaypal.mjs';
import VpPaymentPaysafeAsset from './PaymentPaysafe.mjs';
import VpPaymentPaysafecardAsset from './PaymentPaysafecard.mjs';
import VpPaymentPayuAsset from './PaymentPayu.mjs';
import VpPaymentPointspayAsset from './PaymentPointspay.mjs';
import VpPaymentPostepayAsset from './PaymentPostepay.mjs';
import VpPaymentPostfinanceCardAsset from './PaymentPostfinanceCard.mjs';
import VpPaymentPostfinanceEFinanceAsset from './PaymentPostfinanceEFinance.mjs';
import VpPaymentPowerpayAsset from './PaymentPowerpay.mjs';
import VpPaymentPrzelewy24Asset from './PaymentPrzelewy24.mjs';
import VpPaymentQiwiAsset from './PaymentQiwi.mjs';
import VpPaymentSatispayAsset from './PaymentSatispay.mjs';
import VpPaymentScalapayAsset from './PaymentScalapay.mjs';
import VpPaymentSepaAsset from './PaymentSepa.mjs';
import VpPaymentSequraAsset from './PaymentSequra.mjs';
import VpPaymentSezzleAsset from './PaymentSezzle.mjs';
import VpPaymentShopPayAsset from './PaymentShopPay.mjs';
import VpPaymentSkrillAsset from './PaymentSkrill.mjs';
import VpPaymentSofortAsset from './PaymentSofort.mjs';
import VpPaymentSpiritOfCadeauAsset from './PaymentSpiritOfCadeau.mjs';
import VpPaymentStripeAsset from './PaymentStripe.mjs';
import VpPaymentTabbyAsset from './PaymentTabby.mjs';
import VpPaymentTwintAsset from './PaymentTwint.mjs';
import VpPaymentUnionpayAsset from './PaymentUnionpay.mjs';
import VpPaymentUnzerAsset from './PaymentUnzer.mjs';
import VpPaymentVenmoAsset from './PaymentVenmo.mjs';
import VpPaymentVerifoneAsset from './PaymentVerifone.mjs';
import VpPaymentVisaElectronAsset from './PaymentVisaElectron.mjs';
import VpPaymentVisaLogoAsset from './PaymentVisaLogo.mjs';
import VpPaymentWebmoneyAsset from './PaymentWebmoney.mjs';
import VpPaymentWechatPayAsset from './PaymentWechatPay.mjs';
import VpPaymentWesternunionAsset from './PaymentWesternunion.mjs';
import VpPaymentYampiAsset from './PaymentYampi.mjs';
import VpPaymentYandexpayAsset from './PaymentYandexpay.mjs';
import VpPaymentZarinpalAsset from './PaymentZarinpal.mjs';
import VpPaymentZippayAsset from './PaymentZippay.mjs';
import VpSocialFacebookBlackAsset from './SocialFacebookBlack.mjs';
import VpSocialFacebookOriginalAsset from './SocialFacebookOriginal.mjs';
import VpSocialFacebookWhiteAsset from './SocialFacebookWhite.mjs';
import VpSocialInstagramBlackAsset from './SocialInstagramBlack.mjs';
import VpSocialInstagramOriginalAsset from './SocialInstagramOriginal.mjs';
import VpSocialInstagramWhiteAsset from './SocialInstagramWhite.mjs';
import VpSocialKakaoBlackAsset from './SocialKakaoBlack.mjs';
import VpSocialKakaoOriginalAsset from './SocialKakaoOriginal.mjs';
import VpSocialKakaoWhiteAsset from './SocialKakaoWhite.mjs';
import VpSocialLineBlackAsset from './SocialLineBlack.mjs';
import VpSocialLineOriginalAsset from './SocialLineOriginal.mjs';
import VpSocialLineWhiteAsset from './SocialLineWhite.mjs';
import VpSocialLinkedinBlackAsset from './SocialLinkedinBlack.mjs';
import VpSocialLinkedinOriginalAsset from './SocialLinkedinOriginal.mjs';
import VpSocialLinkedinWhiteAsset from './SocialLinkedinWhite.mjs';
import VpSocialNaverBlackAsset from './SocialNaverBlack.mjs';
import VpSocialNaverOriginalAsset from './SocialNaverOriginal.mjs';
import VpSocialNaverWhiteAsset from './SocialNaverWhite.mjs';
import VpSocialPinterestBlackAsset from './SocialPinterestBlack.mjs';
import VpSocialPinterestOriginalAsset from './SocialPinterestOriginal.mjs';
import VpSocialPinterestWhiteAsset from './SocialPinterestWhite.mjs';
import VpSocialTiktokBlackAsset from './SocialTiktokBlack.mjs';
import VpSocialTiktokOriginalAsset from './SocialTiktokOriginal.mjs';
import VpSocialTiktokWhiteAsset from './SocialTiktokWhite.mjs';
import VpSocialWhatsappBlackAsset from './SocialWhatsappBlack.mjs';
import VpSocialWhatsappOriginalAsset from './SocialWhatsappOriginal.mjs';
import VpSocialWhatsappWhiteAsset from './SocialWhatsappWhite.mjs';
import VpSocialXBlackAsset from './SocialXBlack.mjs';
import VpSocialXOriginalAsset from './SocialXOriginal.mjs';
import VpSocialXWhiteAsset from './SocialXWhite.mjs';
import VpSocialYoutubeBlackAsset from './SocialYoutubeBlack.mjs';
import VpSocialYoutubeOriginalAsset from './SocialYoutubeOriginal.mjs';
import VpSocialYoutubeWhiteAsset from './SocialYoutubeWhite.mjs';

const getAssetsMap = () => ({
  "delivery-dhl": VpDeliveryDhlAsset,
  "delivery-hermes": VpDeliveryHermesAsset,
  "flag-ad": VpFlagAdAsset,
  "flag-ae": VpFlagAeAsset,
  "flag-af": VpFlagAfAsset,
  "flag-ag": VpFlagAgAsset,
  "flag-ai": VpFlagAiAsset,
  "flag-al": VpFlagAlAsset,
  "flag-am": VpFlagAmAsset,
  "flag-an": VpFlagAnAsset,
  "flag-ao": VpFlagAoAsset,
  "flag-ar": VpFlagArAsset,
  "flag-as": VpFlagAsAsset,
  "flag-at": VpFlagAtAsset,
  "flag-au": VpFlagAuAsset,
  "flag-aw": VpFlagAwAsset,
  "flag-ax": VpFlagAxAsset,
  "flag-az": VpFlagAzAsset,
  "flag-ba": VpFlagBaAsset,
  "flag-bb": VpFlagBbAsset,
  "flag-bd": VpFlagBdAsset,
  "flag-be": VpFlagBeAsset,
  "flag-bf": VpFlagBfAsset,
  "flag-bg": VpFlagBgAsset,
  "flag-bh": VpFlagBhAsset,
  "flag-bi": VpFlagBiAsset,
  "flag-bj": VpFlagBjAsset,
  "flag-bl": VpFlagBlAsset,
  "flag-bm": VpFlagBmAsset,
  "flag-bn": VpFlagBnAsset,
  "flag-bo": VpFlagBoAsset,
  "flag-br": VpFlagBrAsset,
  "flag-bs": VpFlagBsAsset,
  "flag-bt": VpFlagBtAsset,
  "flag-bv": VpFlagBvAsset,
  "flag-bw": VpFlagBwAsset,
  "flag-by": VpFlagByAsset,
  "flag-bz": VpFlagBzAsset,
  "flag-ca": VpFlagCaAsset,
  "flag-caf": VpFlagCafAsset,
  "flag-cas": VpFlagCasAsset,
  "flag-cc": VpFlagCcAsset,
  "flag-cd": VpFlagCdAsset,
  "flag-ceu": VpFlagCeuAsset,
  "flag-cf": VpFlagCfAsset,
  "flag-cg": VpFlagCgAsset,
  "flag-ch": VpFlagChAsset,
  "flag-ci": VpFlagCiAsset,
  "flag-ck": VpFlagCkAsset,
  "flag-cl": VpFlagClAsset,
  "flag-cm": VpFlagCmAsset,
  "flag-cn": VpFlagCnAsset,
  "flag-cna": VpFlagCnaAsset,
  "flag-co": VpFlagCoAsset,
  "flag-coc": VpFlagCocAsset,
  "flag-cr": VpFlagCrAsset,
  "flag-csa": VpFlagCsaAsset,
  "flag-cu": VpFlagCuAsset,
  "flag-cv": VpFlagCvAsset,
  "flag-cw": VpFlagCwAsset,
  "flag-cx": VpFlagCxAsset,
  "flag-cy": VpFlagCyAsset,
  "flag-cz": VpFlagCzAsset,
  "flag-de": VpFlagDeAsset,
  "flag-dj": VpFlagDjAsset,
  "flag-dk": VpFlagDkAsset,
  "flag-dm": VpFlagDmAsset,
  "flag-do": VpFlagDoAsset,
  "flag-dz": VpFlagDzAsset,
  "flag-ec": VpFlagEcAsset,
  "flag-ee": VpFlagEeAsset,
  "flag-eg": VpFlagEgAsset,
  "flag-eh": VpFlagEhAsset,
  "flag-er": VpFlagErAsset,
  "flag-es": VpFlagEsAsset,
  "flag-et": VpFlagEtAsset,
  "flag-eu": VpFlagEuAsset,
  "flag-fi": VpFlagFiAsset,
  "flag-fj": VpFlagFjAsset,
  "flag-fk": VpFlagFkAsset,
  "flag-fm": VpFlagFmAsset,
  "flag-fo": VpFlagFoAsset,
  "flag-fr": VpFlagFrAsset,
  "flag-ga": VpFlagGaAsset,
  "flag-gb-eng": VpFlagGbEngAsset,
  "flag-gb-nir": VpFlagGbNirAsset,
  "flag-gb-sct": VpFlagGbSctAsset,
  "flag-gb-wls": VpFlagGbWlsAsset,
  "flag-gb-zet": VpFlagGbZetAsset,
  "flag-gb": VpFlagGbAsset,
  "flag-gd": VpFlagGdAsset,
  "flag-ge": VpFlagGeAsset,
  "flag-gf": VpFlagGfAsset,
  "flag-gg": VpFlagGgAsset,
  "flag-gh": VpFlagGhAsset,
  "flag-gi": VpFlagGiAsset,
  "flag-gl": VpFlagGlAsset,
  "flag-gm": VpFlagGmAsset,
  "flag-gn": VpFlagGnAsset,
  "flag-gp": VpFlagGpAsset,
  "flag-gq": VpFlagGqAsset,
  "flag-gr": VpFlagGrAsset,
  "flag-gs": VpFlagGsAsset,
  "flag-gt": VpFlagGtAsset,
  "flag-gu": VpFlagGuAsset,
  "flag-gw": VpFlagGwAsset,
  "flag-gy": VpFlagGyAsset,
  "flag-hk": VpFlagHkAsset,
  "flag-hm": VpFlagHmAsset,
  "flag-hn": VpFlagHnAsset,
  "flag-hr": VpFlagHrAsset,
  "flag-ht": VpFlagHtAsset,
  "flag-hu": VpFlagHuAsset,
  "flag-id": VpFlagIdAsset,
  "flag-ie": VpFlagIeAsset,
  "flag-il": VpFlagIlAsset,
  "flag-im": VpFlagImAsset,
  "flag-in": VpFlagInAsset,
  "flag-io": VpFlagIoAsset,
  "flag-iq": VpFlagIqAsset,
  "flag-ir": VpFlagIrAsset,
  "flag-is": VpFlagIsAsset,
  "flag-it": VpFlagItAsset,
  "flag-je": VpFlagJeAsset,
  "flag-jm": VpFlagJmAsset,
  "flag-jo": VpFlagJoAsset,
  "flag-jp": VpFlagJpAsset,
  "flag-ke": VpFlagKeAsset,
  "flag-kg": VpFlagKgAsset,
  "flag-kh": VpFlagKhAsset,
  "flag-ki": VpFlagKiAsset,
  "flag-km": VpFlagKmAsset,
  "flag-kn": VpFlagKnAsset,
  "flag-kp": VpFlagKpAsset,
  "flag-kr": VpFlagKrAsset,
  "flag-kw": VpFlagKwAsset,
  "flag-ky": VpFlagKyAsset,
  "flag-kz": VpFlagKzAsset,
  "flag-la": VpFlagLaAsset,
  "flag-lb": VpFlagLbAsset,
  "flag-lc": VpFlagLcAsset,
  "flag-lgbt": VpFlagLgbtAsset,
  "flag-li": VpFlagLiAsset,
  "flag-lk": VpFlagLkAsset,
  "flag-lr": VpFlagLrAsset,
  "flag-ls": VpFlagLsAsset,
  "flag-lt": VpFlagLtAsset,
  "flag-lu": VpFlagLuAsset,
  "flag-lv": VpFlagLvAsset,
  "flag-ly": VpFlagLyAsset,
  "flag-ma": VpFlagMaAsset,
  "flag-mc": VpFlagMcAsset,
  "flag-md": VpFlagMdAsset,
  "flag-me": VpFlagMeAsset,
  "flag-mf": VpFlagMfAsset,
  "flag-mg": VpFlagMgAsset,
  "flag-mh": VpFlagMhAsset,
  "flag-mk": VpFlagMkAsset,
  "flag-ml": VpFlagMlAsset,
  "flag-mm": VpFlagMmAsset,
  "flag-mn": VpFlagMnAsset,
  "flag-mo": VpFlagMoAsset,
  "flag-mp": VpFlagMpAsset,
  "flag-mq": VpFlagMqAsset,
  "flag-mr": VpFlagMrAsset,
  "flag-ms": VpFlagMsAsset,
  "flag-mt": VpFlagMtAsset,
  "flag-mu": VpFlagMuAsset,
  "flag-mv": VpFlagMvAsset,
  "flag-mw": VpFlagMwAsset,
  "flag-mx": VpFlagMxAsset,
  "flag-my": VpFlagMyAsset,
  "flag-mz": VpFlagMzAsset,
  "flag-na": VpFlagNaAsset,
  "flag-nc": VpFlagNcAsset,
  "flag-ne": VpFlagNeAsset,
  "flag-nf": VpFlagNfAsset,
  "flag-ng": VpFlagNgAsset,
  "flag-ni": VpFlagNiAsset,
  "flag-nl": VpFlagNlAsset,
  "flag-no": VpFlagNoAsset,
  "flag-np": VpFlagNpAsset,
  "flag-nr": VpFlagNrAsset,
  "flag-nu": VpFlagNuAsset,
  "flag-nz": VpFlagNzAsset,
  "flag-om": VpFlagOmAsset,
  "flag-pa": VpFlagPaAsset,
  "flag-pe": VpFlagPeAsset,
  "flag-pf": VpFlagPfAsset,
  "flag-pg": VpFlagPgAsset,
  "flag-ph": VpFlagPhAsset,
  "flag-pk": VpFlagPkAsset,
  "flag-pl": VpFlagPlAsset,
  "flag-pm": VpFlagPmAsset,
  "flag-pn": VpFlagPnAsset,
  "flag-pr": VpFlagPrAsset,
  "flag-ps": VpFlagPsAsset,
  "flag-pt": VpFlagPtAsset,
  "flag-pw": VpFlagPwAsset,
  "flag-py": VpFlagPyAsset,
  "flag-qa": VpFlagQaAsset,
  "flag-re": VpFlagReAsset,
  "flag-ro": VpFlagRoAsset,
  "flag-rs": VpFlagRsAsset,
  "flag-ru": VpFlagRuAsset,
  "flag-rw": VpFlagRwAsset,
  "flag-sa": VpFlagSaAsset,
  "flag-sb": VpFlagSbAsset,
  "flag-sc": VpFlagScAsset,
  "flag-sd": VpFlagSdAsset,
  "flag-se": VpFlagSeAsset,
  "flag-sg": VpFlagSgAsset,
  "flag-sh": VpFlagShAsset,
  "flag-si": VpFlagSiAsset,
  "flag-sj": VpFlagSjAsset,
  "flag-sk": VpFlagSkAsset,
  "flag-sl": VpFlagSlAsset,
  "flag-sm": VpFlagSmAsset,
  "flag-sn": VpFlagSnAsset,
  "flag-so": VpFlagSoAsset,
  "flag-sr": VpFlagSrAsset,
  "flag-ss": VpFlagSsAsset,
  "flag-st": VpFlagStAsset,
  "flag-sv": VpFlagSvAsset,
  "flag-sx": VpFlagSxAsset,
  "flag-sy": VpFlagSyAsset,
  "flag-sz": VpFlagSzAsset,
  "flag-tc": VpFlagTcAsset,
  "flag-td": VpFlagTdAsset,
  "flag-tg": VpFlagTgAsset,
  "flag-th": VpFlagThAsset,
  "flag-tj": VpFlagTjAsset,
  "flag-tk": VpFlagTkAsset,
  "flag-tl": VpFlagTlAsset,
  "flag-tm": VpFlagTmAsset,
  "flag-tn": VpFlagTnAsset,
  "flag-to": VpFlagToAsset,
  "flag-tr": VpFlagTrAsset,
  "flag-tt": VpFlagTtAsset,
  "flag-tv": VpFlagTvAsset,
  "flag-tz": VpFlagTzAsset,
  "flag-ua": VpFlagUaAsset,
  "flag-ug": VpFlagUgAsset,
  "flag-um": VpFlagUmAsset,
  "flag-us-ca": VpFlagUsCaAsset,
  "flag-us": VpFlagUsAsset,
  "flag-uy": VpFlagUyAsset,
  "flag-uz": VpFlagUzAsset,
  "flag-va": VpFlagVaAsset,
  "flag-vc": VpFlagVcAsset,
  "flag-ve": VpFlagVeAsset,
  "flag-vg": VpFlagVgAsset,
  "flag-vi": VpFlagViAsset,
  "flag-vn": VpFlagVnAsset,
  "flag-vu": VpFlagVuAsset,
  "flag-wf": VpFlagWfAsset,
  "flag-ws": VpFlagWsAsset,
  "flag-ww": VpFlagWwAsset,
  "flag-xk": VpFlagXkAsset,
  "flag-ye": VpFlagYeAsset,
  "flag-yt": VpFlagYtAsset,
  "flag-za": VpFlagZaAsset,
  "flag-zm": VpFlagZmAsset,
  "flag-zw": VpFlagZwAsset,
  "logo-decathlon-core-symbol-brand": VpLogoDecathlonCoreSymbolBrandAsset,
  "logo-decathlon-core-symbol-white": VpLogoDecathlonCoreSymbolWhiteAsset,
  "logo-decathlon-favicon": VpLogoDecathlonFaviconAsset,
  "logo-decathlon-lockup-primary-brand": VpLogoDecathlonLockupPrimaryBrandAsset,
  "logo-decathlon-lockup-primary-white": VpLogoDecathlonLockupPrimaryWhiteAsset,
  "logo-decathlon-lockup-stacked-brand": VpLogoDecathlonLockupStackedBrandAsset,
  "logo-decathlon-lockup-stacked-white": VpLogoDecathlonLockupStackedWhiteAsset,
  "logo-decathlon-store-pin-selected": VpLogoDecathlonStorePinSelectedAsset,
  "logo-decathlon-store-pin": VpLogoDecathlonStorePinAsset,
  "logo-decathlon-wordmark-brand": VpLogoDecathlonWordmarkBrandAsset,
  "logo-decathlon-wordmark-white": VpLogoDecathlonWordmarkWhiteAsset,
  "payment-addi": VpPaymentAddiAsset,
  "payment-affirm": VpPaymentAffirmAsset,
  "payment-afterpay-riverty": VpPaymentAfterpayRivertyAsset,
  "payment-afterpay": VpPaymentAfterpayAsset,
  "payment-alipay": VpPaymentAlipayAsset,
  "payment-amazonpay": VpPaymentAmazonpayAsset,
  "payment-amex": VpPaymentAmexAsset,
  "payment-applepay": VpPaymentApplepayAsset,
  "payment-atome": VpPaymentAtomeAsset,
  "payment-bancontact-classic": VpPaymentBancontactClassicAsset,
  "payment-bancontact-payconiq": VpPaymentBancontactPayconiqAsset,
  "payment-belfius": VpPaymentBelfiusAsset,
  "payment-bitcoin-accepted-here": VpPaymentBitcoinAcceptedHereAsset,
  "payment-bitcoin-logo": VpPaymentBitcoinLogoAsset,
  "payment-bitpay": VpPaymentBitpayAsset,
  "payment-boleto": VpPaymentBoletoAsset,
  "payment-bvr": VpPaymentBvrAsset,
  "payment-cadhoc": VpPaymentCadhocAsset,
  "payment-cash": VpPaymentCashAsset,
  "payment-cb": VpPaymentCbAsset,
  "payment-check": VpPaymentCheckAsset,
  "payment-citadele": VpPaymentCitadeleAsset,
  "payment-clickandbuy": VpPaymentClickandbuyAsset,
  "payment-dinersclubinternational": VpPaymentDinersclubinternationalAsset,
  "payment-discover": VpPaymentDiscoverAsset,
  "payment-dwolla": VpPaymentDwollaAsset,
  "payment-elo": VpPaymentEloAsset,
  "payment-eps": VpPaymentEpsAsset,
  "payment-ethereum": VpPaymentEthereumAsset,
  "payment-eway": VpPaymentEwayAsset,
  "payment-giropay": VpPaymentGiropayAsset,
  "payment-googlepay": VpPaymentGooglepayAsset,
  "payment-grab": VpPaymentGrabAsset,
  "payment-hipercard": VpPaymentHipercardAsset,
  "payment-ideal": VpPaymentIdealAsset,
  "payment-illicado": VpPaymentIllicadoAsset,
  "payment-ing": VpPaymentIngAsset,
  "payment-ingenico": VpPaymentIngenicoAsset,
  "payment-interac": VpPaymentInteracAsset,
  "payment-jcb": VpPaymentJcbAsset,
  "payment-kbc": VpPaymentKbcAsset,
  "payment-klarna": VpPaymentKlarnaAsset,
  "payment-kueskipay": VpPaymentKueskipayAsset,
  "payment-laybuy-1": VpPaymentLaybuy1Asset,
  "payment-laybuy": VpPaymentLaybuyAsset,
  "payment-layup": VpPaymentLayupAsset,
  "payment-maestro-logo": VpPaymentMaestroLogoAsset,
  "payment-maestro-with-text": VpPaymentMaestroWithTextAsset,
  "payment-mastercard-id-check": VpPaymentMastercardIdCheckAsset,
  "payment-mastercard-logo": VpPaymentMastercardLogoAsset,
  "payment-mastercard-with-text": VpPaymentMastercardWithTextAsset,
  "payment-mb-multibanco": VpPaymentMbMultibancoAsset,
  "payment-mb-way": VpPaymentMbWayAsset,
  "payment-mercado-pago": VpPaymentMercadoPagoAsset,
  "payment-mnp": VpPaymentMnpAsset,
  "payment-monero": VpPaymentMoneroAsset,
  "payment-neteller": VpPaymentNetellerAsset,
  "payment-oney-3x-4x": VpPaymentOney3X4XAsset,
  "payment-oney-3x": VpPaymentOney3XAsset,
  "payment-oney-4x": VpPaymentOney4XAsset,
  "payment-oney-logo": VpPaymentOneyLogoAsset,
  "payment-pace": VpPaymentPaceAsset,
  "payment-pagodil": VpPaymentPagodilAsset,
  "payment-paylib": VpPaymentPaylibAsset,
  "payment-paymill": VpPaymentPaymillAsset,
  "payment-payoneer": VpPaymentPayoneerAsset,
  "payment-paypal": VpPaymentPaypalAsset,
  "payment-paysafe": VpPaymentPaysafeAsset,
  "payment-paysafecard": VpPaymentPaysafecardAsset,
  "payment-payu": VpPaymentPayuAsset,
  "payment-pointspay": VpPaymentPointspayAsset,
  "payment-postepay": VpPaymentPostepayAsset,
  "payment-postfinance-card": VpPaymentPostfinanceCardAsset,
  "payment-postfinance-e-finance": VpPaymentPostfinanceEFinanceAsset,
  "payment-powerpay": VpPaymentPowerpayAsset,
  "payment-przelewy24": VpPaymentPrzelewy24Asset,
  "payment-qiwi": VpPaymentQiwiAsset,
  "payment-satispay": VpPaymentSatispayAsset,
  "payment-scalapay": VpPaymentScalapayAsset,
  "payment-sepa": VpPaymentSepaAsset,
  "payment-sequra": VpPaymentSequraAsset,
  "payment-sezzle": VpPaymentSezzleAsset,
  "payment-shop-pay": VpPaymentShopPayAsset,
  "payment-skrill": VpPaymentSkrillAsset,
  "payment-sofort": VpPaymentSofortAsset,
  "payment-spirit-of-cadeau": VpPaymentSpiritOfCadeauAsset,
  "payment-stripe": VpPaymentStripeAsset,
  "payment-tabby": VpPaymentTabbyAsset,
  "payment-twint": VpPaymentTwintAsset,
  "payment-unionpay": VpPaymentUnionpayAsset,
  "payment-unzer": VpPaymentUnzerAsset,
  "payment-venmo": VpPaymentVenmoAsset,
  "payment-verifone": VpPaymentVerifoneAsset,
  "payment-visa-electron": VpPaymentVisaElectronAsset,
  "payment-visa-logo": VpPaymentVisaLogoAsset,
  "payment-webmoney": VpPaymentWebmoneyAsset,
  "payment-wechat-pay": VpPaymentWechatPayAsset,
  "payment-westernunion": VpPaymentWesternunionAsset,
  "payment-yampi": VpPaymentYampiAsset,
  "payment-yandexpay": VpPaymentYandexpayAsset,
  "payment-zarinpal": VpPaymentZarinpalAsset,
  "payment-zippay": VpPaymentZippayAsset,
  "social-facebook-black": VpSocialFacebookBlackAsset,
  "social-facebook-original": VpSocialFacebookOriginalAsset,
  "social-facebook-white": VpSocialFacebookWhiteAsset,
  "social-instagram-black": VpSocialInstagramBlackAsset,
  "social-instagram-original": VpSocialInstagramOriginalAsset,
  "social-instagram-white": VpSocialInstagramWhiteAsset,
  "social-kakao-black": VpSocialKakaoBlackAsset,
  "social-kakao-original": VpSocialKakaoOriginalAsset,
  "social-kakao-white": VpSocialKakaoWhiteAsset,
  "social-line-black": VpSocialLineBlackAsset,
  "social-line-original": VpSocialLineOriginalAsset,
  "social-line-white": VpSocialLineWhiteAsset,
  "social-linkedin-black": VpSocialLinkedinBlackAsset,
  "social-linkedin-original": VpSocialLinkedinOriginalAsset,
  "social-linkedin-white": VpSocialLinkedinWhiteAsset,
  "social-naver-black": VpSocialNaverBlackAsset,
  "social-naver-original": VpSocialNaverOriginalAsset,
  "social-naver-white": VpSocialNaverWhiteAsset,
  "social-pinterest-black": VpSocialPinterestBlackAsset,
  "social-pinterest-original": VpSocialPinterestOriginalAsset,
  "social-pinterest-white": VpSocialPinterestWhiteAsset,
  "social-tiktok-black": VpSocialTiktokBlackAsset,
  "social-tiktok-original": VpSocialTiktokOriginalAsset,
  "social-tiktok-white": VpSocialTiktokWhiteAsset,
  "social-whatsapp-black": VpSocialWhatsappBlackAsset,
  "social-whatsapp-original": VpSocialWhatsappOriginalAsset,
  "social-whatsapp-white": VpSocialWhatsappWhiteAsset,
  "social-x-black": VpSocialXBlackAsset,
  "social-x-original": VpSocialXOriginalAsset,
  "social-x-white": VpSocialXWhiteAsset,
  "social-youtube-black": VpSocialYoutubeBlackAsset,
  "social-youtube-original": VpSocialYoutubeOriginalAsset,
  "social-youtube-white": VpSocialYoutubeWhiteAsset
});

export { VpDeliveryDhlAsset, VpDeliveryHermesAsset, VpFlagAdAsset, VpFlagAeAsset, VpFlagAfAsset, VpFlagAgAsset, VpFlagAiAsset, VpFlagAlAsset, VpFlagAmAsset, VpFlagAnAsset, VpFlagAoAsset, VpFlagArAsset, VpFlagAsAsset, VpFlagAtAsset, VpFlagAuAsset, VpFlagAwAsset, VpFlagAxAsset, VpFlagAzAsset, VpFlagBaAsset, VpFlagBbAsset, VpFlagBdAsset, VpFlagBeAsset, VpFlagBfAsset, VpFlagBgAsset, VpFlagBhAsset, VpFlagBiAsset, VpFlagBjAsset, VpFlagBlAsset, VpFlagBmAsset, VpFlagBnAsset, VpFlagBoAsset, VpFlagBrAsset, VpFlagBsAsset, VpFlagBtAsset, VpFlagBvAsset, VpFlagBwAsset, VpFlagByAsset, VpFlagBzAsset, VpFlagCaAsset, VpFlagCafAsset, VpFlagCasAsset, VpFlagCcAsset, VpFlagCdAsset, VpFlagCeuAsset, VpFlagCfAsset, VpFlagCgAsset, VpFlagChAsset, VpFlagCiAsset, VpFlagCkAsset, VpFlagClAsset, VpFlagCmAsset, VpFlagCnAsset, VpFlagCnaAsset, VpFlagCoAsset, VpFlagCocAsset, VpFlagCrAsset, VpFlagCsaAsset, VpFlagCuAsset, VpFlagCvAsset, VpFlagCwAsset, VpFlagCxAsset, VpFlagCyAsset, VpFlagCzAsset, VpFlagDeAsset, VpFlagDjAsset, VpFlagDkAsset, VpFlagDmAsset, VpFlagDoAsset, VpFlagDzAsset, VpFlagEcAsset, VpFlagEeAsset, VpFlagEgAsset, VpFlagEhAsset, VpFlagErAsset, VpFlagEsAsset, VpFlagEtAsset, VpFlagEuAsset, VpFlagFiAsset, VpFlagFjAsset, VpFlagFkAsset, VpFlagFmAsset, VpFlagFoAsset, VpFlagFrAsset, VpFlagGaAsset, VpFlagGbAsset, VpFlagGbEngAsset, VpFlagGbNirAsset, VpFlagGbSctAsset, VpFlagGbWlsAsset, VpFlagGbZetAsset, VpFlagGdAsset, VpFlagGeAsset, VpFlagGfAsset, VpFlagGgAsset, VpFlagGhAsset, VpFlagGiAsset, VpFlagGlAsset, VpFlagGmAsset, VpFlagGnAsset, VpFlagGpAsset, VpFlagGqAsset, VpFlagGrAsset, VpFlagGsAsset, VpFlagGtAsset, VpFlagGuAsset, VpFlagGwAsset, VpFlagGyAsset, VpFlagHkAsset, VpFlagHmAsset, VpFlagHnAsset, VpFlagHrAsset, VpFlagHtAsset, VpFlagHuAsset, VpFlagIdAsset, VpFlagIeAsset, VpFlagIlAsset, VpFlagImAsset, VpFlagInAsset, VpFlagIoAsset, VpFlagIqAsset, VpFlagIrAsset, VpFlagIsAsset, VpFlagItAsset, VpFlagJeAsset, VpFlagJmAsset, VpFlagJoAsset, VpFlagJpAsset, VpFlagKeAsset, VpFlagKgAsset, VpFlagKhAsset, VpFlagKiAsset, VpFlagKmAsset, VpFlagKnAsset, VpFlagKpAsset, VpFlagKrAsset, VpFlagKwAsset, VpFlagKyAsset, VpFlagKzAsset, VpFlagLaAsset, VpFlagLbAsset, VpFlagLcAsset, VpFlagLgbtAsset, VpFlagLiAsset, VpFlagLkAsset, VpFlagLrAsset, VpFlagLsAsset, VpFlagLtAsset, VpFlagLuAsset, VpFlagLvAsset, VpFlagLyAsset, VpFlagMaAsset, VpFlagMcAsset, VpFlagMdAsset, VpFlagMeAsset, VpFlagMfAsset, VpFlagMgAsset, VpFlagMhAsset, VpFlagMkAsset, VpFlagMlAsset, VpFlagMmAsset, VpFlagMnAsset, VpFlagMoAsset, VpFlagMpAsset, VpFlagMqAsset, VpFlagMrAsset, VpFlagMsAsset, VpFlagMtAsset, VpFlagMuAsset, VpFlagMvAsset, VpFlagMwAsset, VpFlagMxAsset, VpFlagMyAsset, VpFlagMzAsset, VpFlagNaAsset, VpFlagNcAsset, VpFlagNeAsset, VpFlagNfAsset, VpFlagNgAsset, VpFlagNiAsset, VpFlagNlAsset, VpFlagNoAsset, VpFlagNpAsset, VpFlagNrAsset, VpFlagNuAsset, VpFlagNzAsset, VpFlagOmAsset, VpFlagPaAsset, VpFlagPeAsset, VpFlagPfAsset, VpFlagPgAsset, VpFlagPhAsset, VpFlagPkAsset, VpFlagPlAsset, VpFlagPmAsset, VpFlagPnAsset, VpFlagPrAsset, VpFlagPsAsset, VpFlagPtAsset, VpFlagPwAsset, VpFlagPyAsset, VpFlagQaAsset, VpFlagReAsset, VpFlagRoAsset, VpFlagRsAsset, VpFlagRuAsset, VpFlagRwAsset, VpFlagSaAsset, VpFlagSbAsset, VpFlagScAsset, VpFlagSdAsset, VpFlagSeAsset, VpFlagSgAsset, VpFlagShAsset, VpFlagSiAsset, VpFlagSjAsset, VpFlagSkAsset, VpFlagSlAsset, VpFlagSmAsset, VpFlagSnAsset, VpFlagSoAsset, VpFlagSrAsset, VpFlagSsAsset, VpFlagStAsset, VpFlagSvAsset, VpFlagSxAsset, VpFlagSyAsset, VpFlagSzAsset, VpFlagTcAsset, VpFlagTdAsset, VpFlagTgAsset, VpFlagThAsset, VpFlagTjAsset, VpFlagTkAsset, VpFlagTlAsset, VpFlagTmAsset, VpFlagTnAsset, VpFlagToAsset, VpFlagTrAsset, VpFlagTtAsset, VpFlagTvAsset, VpFlagTzAsset, VpFlagUaAsset, VpFlagUgAsset, VpFlagUmAsset, VpFlagUsAsset, VpFlagUsCaAsset, VpFlagUyAsset, VpFlagUzAsset, VpFlagVaAsset, VpFlagVcAsset, VpFlagVeAsset, VpFlagVgAsset, VpFlagViAsset, VpFlagVnAsset, VpFlagVuAsset, VpFlagWfAsset, VpFlagWsAsset, VpFlagWwAsset, VpFlagXkAsset, VpFlagYeAsset, VpFlagYtAsset, VpFlagZaAsset, VpFlagZmAsset, VpFlagZwAsset, VpLogoDecathlonCoreSymbolBrandAsset, VpLogoDecathlonCoreSymbolWhiteAsset, VpLogoDecathlonFaviconAsset, VpLogoDecathlonLockupPrimaryBrandAsset, VpLogoDecathlonLockupPrimaryWhiteAsset, VpLogoDecathlonLockupStackedBrandAsset, VpLogoDecathlonLockupStackedWhiteAsset, VpLogoDecathlonStorePinAsset, VpLogoDecathlonStorePinSelectedAsset, VpLogoDecathlonWordmarkBrandAsset, VpLogoDecathlonWordmarkWhiteAsset, VpPaymentAddiAsset, VpPaymentAffirmAsset, VpPaymentAfterpayAsset, VpPaymentAfterpayRivertyAsset, VpPaymentAlipayAsset, VpPaymentAmazonpayAsset, VpPaymentAmexAsset, VpPaymentApplepayAsset, VpPaymentAtomeAsset, VpPaymentBancontactClassicAsset, VpPaymentBancontactPayconiqAsset, VpPaymentBelfiusAsset, VpPaymentBitcoinAcceptedHereAsset, VpPaymentBitcoinLogoAsset, VpPaymentBitpayAsset, VpPaymentBoletoAsset, VpPaymentBvrAsset, VpPaymentCadhocAsset, VpPaymentCashAsset, VpPaymentCbAsset, VpPaymentCheckAsset, VpPaymentCitadeleAsset, VpPaymentClickandbuyAsset, VpPaymentDinersclubinternationalAsset, VpPaymentDiscoverAsset, VpPaymentDwollaAsset, VpPaymentEloAsset, VpPaymentEpsAsset, VpPaymentEthereumAsset, VpPaymentEwayAsset, VpPaymentGiropayAsset, VpPaymentGooglepayAsset, VpPaymentGrabAsset, VpPaymentHipercardAsset, VpPaymentIdealAsset, VpPaymentIllicadoAsset, VpPaymentIngAsset, VpPaymentIngenicoAsset, VpPaymentInteracAsset, VpPaymentJcbAsset, VpPaymentKbcAsset, VpPaymentKlarnaAsset, VpPaymentKueskipayAsset, VpPaymentLaybuy1Asset, VpPaymentLaybuyAsset, VpPaymentLayupAsset, VpPaymentMaestroLogoAsset, VpPaymentMaestroWithTextAsset, VpPaymentMastercardIdCheckAsset, VpPaymentMastercardLogoAsset, VpPaymentMastercardWithTextAsset, VpPaymentMbMultibancoAsset, VpPaymentMbWayAsset, VpPaymentMercadoPagoAsset, VpPaymentMnpAsset, VpPaymentMoneroAsset, VpPaymentNetellerAsset, VpPaymentOney3X4XAsset, VpPaymentOney3XAsset, VpPaymentOney4XAsset, VpPaymentOneyLogoAsset, VpPaymentPaceAsset, VpPaymentPagodilAsset, VpPaymentPaylibAsset, VpPaymentPaymillAsset, VpPaymentPayoneerAsset, VpPaymentPaypalAsset, VpPaymentPaysafeAsset, VpPaymentPaysafecardAsset, VpPaymentPayuAsset, VpPaymentPointspayAsset, VpPaymentPostepayAsset, VpPaymentPostfinanceCardAsset, VpPaymentPostfinanceEFinanceAsset, VpPaymentPowerpayAsset, VpPaymentPrzelewy24Asset, VpPaymentQiwiAsset, VpPaymentSatispayAsset, VpPaymentScalapayAsset, VpPaymentSepaAsset, VpPaymentSequraAsset, VpPaymentSezzleAsset, VpPaymentShopPayAsset, VpPaymentSkrillAsset, VpPaymentSofortAsset, VpPaymentSpiritOfCadeauAsset, VpPaymentStripeAsset, VpPaymentTabbyAsset, VpPaymentTwintAsset, VpPaymentUnionpayAsset, VpPaymentUnzerAsset, VpPaymentVenmoAsset, VpPaymentVerifoneAsset, VpPaymentVisaElectronAsset, VpPaymentVisaLogoAsset, VpPaymentWebmoneyAsset, VpPaymentWechatPayAsset, VpPaymentWesternunionAsset, VpPaymentYampiAsset, VpPaymentYandexpayAsset, VpPaymentZarinpalAsset, VpPaymentZippayAsset, VpSocialFacebookBlackAsset, VpSocialFacebookOriginalAsset, VpSocialFacebookWhiteAsset, VpSocialInstagramBlackAsset, VpSocialInstagramOriginalAsset, VpSocialInstagramWhiteAsset, VpSocialKakaoBlackAsset, VpSocialKakaoOriginalAsset, VpSocialKakaoWhiteAsset, VpSocialLineBlackAsset, VpSocialLineOriginalAsset, VpSocialLineWhiteAsset, VpSocialLinkedinBlackAsset, VpSocialLinkedinOriginalAsset, VpSocialLinkedinWhiteAsset, VpSocialNaverBlackAsset, VpSocialNaverOriginalAsset, VpSocialNaverWhiteAsset, VpSocialPinterestBlackAsset, VpSocialPinterestOriginalAsset, VpSocialPinterestWhiteAsset, VpSocialTiktokBlackAsset, VpSocialTiktokOriginalAsset, VpSocialTiktokWhiteAsset, VpSocialWhatsappBlackAsset, VpSocialWhatsappOriginalAsset, VpSocialWhatsappWhiteAsset, VpSocialXBlackAsset, VpSocialXOriginalAsset, VpSocialXWhiteAsset, VpSocialYoutubeBlackAsset, VpSocialYoutubeOriginalAsset, VpSocialYoutubeWhiteAsset, getAssetsMap as default, getAssetsMap };
